/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { SiteQuery } from '../../types/siteQuery'

interface Meta {
  property: string
  content: string
}
interface SEOProps {
  description?: string
  lang?: string
  meta?: Meta[]
  title: string
  noTemplate?: boolean
  pathname?: string
  image?: string
}

export const SEO = ({
  description,
  lang,
  meta,
  title,
  noTemplate,
  pathname,
  image,
}: SEOProps) => {
  const { site }: { site: SiteQuery } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const canonicalUrl = pathname
    ? `${site.siteMetadata.siteUrl}${pathname}`
    : site.siteMetadata.siteUrl
  const ogImageUrl = image
    ? image.startsWith('http')
      ? image
      : `${site.siteMetadata.siteUrl}${image}`
    : `${site.siteMetadata.siteUrl}/icons/icon-512x512.png`

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={noTemplate ? `%s` : `%s | ${site.siteMetadata.title}`}
      link={[
        {
          rel: `canonical`,
          href: canonicalUrl,
        },
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: canonicalUrl,
        },
        {
          property: `og:image`,
          content: ogImageUrl,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `tr`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}
